import React, { useEffect, useRef, useMemo } from "react"
import {
  Route,
  Redirect,
  withRouter,
  RouteComponentProps,
} from "react-router-dom"
import { RouteTypes } from "routes/routes"
import { find, get, map } from "lodash"
import ReactResizeDetector from "react-resize-detector"
import { SymbolDetail } from "components/pages/others/symbolDetail"
import Toast from "components/pages/others/toast"
import { SubNav } from "components/molecules/nav"
import { CoverLoading } from "components/atoms/utils"
import { checkIsSp, checkIsIOS } from "utils/util"
import SpChartModal from "components/molecules/chart/spChartModal"
import SpIndicatorChart from "components/molecules/chart/spIndicatorChartModal"
import { UserStorage } from "utils/userStorage"
import ClassNames from "classnames"
import { checkCacheTime } from "polling-cache-time"
import { useSelector } from "react-redux"
import { useChangeMenuTrigger } from "../../actions/customHook/changeMenu"

export type MainProp = {
  path: string
  name: string
}

export type ParentRouteProps = MainProp & {
  component?: React.FC
  renderingInMain?: boolean
}

export type ChildrenRouteProps = MainProp & {
  component: string | React.FC
}

export type MainContentsType = RouteComponentProps & {
  route: RouteTypes
  main: boolean
}

export const useMainContents = (props: any) => {
  const contents = useRef(null)
  useEffect(() => {
    if (!UserStorage.SelectCountry.get()) {
      UserStorage.SelectCountry.set(["日本", "米国"])
    }
  }, [])

  //DEMO版なのでGetCacheTime呼ばない
  // useEffect(() => {
  //   checkCacheTime.start()
  // }, [])

  useEffect(() => {
    //Routingしている中身のscrollTopを行う
    if (!!contents && !!contents.current) contents.current.scrollTo(0, 0)
  }, [props.location.pathname])

  const route = find(props.route, (row: MainProp) =>
    props.location.pathname.includes(row.path)
  )

  const childrenRoute: Array<MainProp> | [] = get(route, "routes", [])
  return { route, childrenRoute }
}

const MainContents: React.FC<MainContentsType> = props => {
  const { route, childrenRoute } = useMainContents(props)
  const isPhone = useMemo(() => {
    return checkIsSp()
  }, [])
  const isIOS = useMemo(() => {
    return checkIsIOS()
  }, [])
  const isShowSymbolDetail = useSelector(
    (state: { symbolDetail: { show: boolean } }) => state.symbolDetail.show
  )

  return (
    <main className={ClassNames("main-content", { ios: isIOS })}>
      <Toast />
      {isPhone && (
        <>
          <SpChartModal />
          <SpIndicatorChart />
        </>
      )}
      {get(route, "path") !== "/news" && (
        <ReactResizeDetector
          handleWidth={true}
          render={({ width }) => {
            return (
              <>
                {!isPhone && (
                  <SubNav
                    route={childrenRoute}
                    pathname={props.location.pathname}
                    windowWidth={width}
                  />
                )}
              </>
            )
          }}
        />
      )}
      {props.main && (
        <Route path={"/"} exact component={() => <Redirect to={"/top"} />} />
      )}
      {props.route.map((row: ParentRouteProps, i: number) => (
        <Route
          exact={row.renderingInMain}
          key={i}
          path={row.path}
          component={row.component}
        />
      ))}
      {route !== undefined && route.renderingInMain
        ? map(childrenRoute, (row: ChildrenRouteProps, key: number) => (
            <Route
              key={key}
              path={row.path}
              //props追加などで汎用的にするために、このように指定
              component={() => React.createElement(row.component)}
            />
          ))
        : null}
      {/*個別銘柄詳細は全体的にローディング画面を出したい*/}
      <CoverLoading
        targetCls={ClassNames({
          "main-container": !isShowSymbolDetail,
          ai: isShowSymbolDetail,
        })}
      />
      {isPhone && <SymbolDetail />}
    </main>
  )
}

export default withRouter(MainContents)
